import { ethers } from 'ethers'
import xcadAbi from '~abis/index'
import { PROVIDER_URL, XCADToken } from '~crypto/index'

export async function fetchWalletBalance(ethereumAddress) {
  const provider = new ethers.providers.JsonRpcProvider(
    PROVIDER_URL[process.env.GATSBY_PUBLIC_NETWORK]
  )

  const xcadContract = new ethers.Contract(
    XCADToken.address.bnb[process.env.GATSBY_PUBLIC_NETWORK],
    xcadAbi,
    provider
  )

  const balance = await xcadContract.balanceOf(ethereumAddress)
  return ethers.utils.formatEther(balance)
}
